import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap,tap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { EndpointsService } from '../services/endpoints.service';

import { CookieService } from 'ngx-cookie-service';
import { GdprConsentService } from '../services/gdpr-consent.service';
import { loginRequest } from '../auth-config';
import { AppComponent } from '../app.component';
import Keycloak from 'keycloak-js';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeycloakService } from '../services/keycloak.service';

@Injectable()
export class AccessDeniedInterceptor implements HttpInterceptor {

  private lastWarningTime: number = 0;

  constructor(
    private authService: MsalService,
    private cookieService: CookieService,
    private gdprConsentService: GdprConsentService,
    private endpointsService: EndpointsService,
    private snackBar: MatSnackBar,
    private keycloakService: KeycloakService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.endpointsService.setAuthSilentToken();

    const isCrudOperation = ['POST', 'PUT', 'DELETE'].includes(req.method);

    return next.handle(req).pipe(


      tap((event: HttpEvent<any>) => {
        const now = Date.now();
        const WARNING_COOLDOWN = 60 * 1000;

        if (isCrudOperation && event instanceof HttpResponse && now - this.lastWarningTime > WARNING_COOLDOWN) {
          this.lastWarningTime = now;
          this.snackBar.open(
            'Changes made in one tab or session will not automatically appear in others. Please refresh any open tabs or sessions to see the latest updates.',
            'Close',
            {
              duration: 6000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['multi-tab-warning-snackbar']

            }
          );


        }
      }),
      catchError((error: HttpErrorResponse) => {

        console.log('Interceptor caught error:', error);

        // Redirect to /permissionError.html on 403, 302, or if redirected to /permissionError.html
        if (
          error.status === 403 ||
          error.status === 302 ||
          (error.url && error.url.includes('/permissionError.html'))
        ) {
 /*          sessionStorage.removeItem(EndpointsService.SESSION_ID);
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/');
          this.cookieService.deleteAll(); */
          // Keycloak logout and redirect
/*           if (this.keycloakService) {
            this.keycloakService.logout(true);
          } else {
            window.location.href = '/permissionError.html';
          } */
          this.keycloakService.logout(true);
          

        } else if (error.status === 451 ) {
          this.gdprConsentService.showOnce();
        }
        return throwError(() => error);
      })
    );
  }

  timeDifference(date1, date2) {
    var diff = Math.abs(date1 - date2);
    var minutes = Math.floor((diff / 1000) / 60);

    //console.log(minutes);
    return minutes;
  }

  getTokenExpirationTimeStamp(token: string): number {
    if (!token || typeof token !== 'string') {
      return 0;
    }
    const parts = token.split(".");
    if (parts.length !== 3) {
      return 0;
    }
    const base64Url = parts[1];
    try {
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      const { exp } = JSON.parse(jsonPayload);
      return exp;
    } catch (e) {
      return 0;
    }
  }
}
